import 'react-slideshow-image/dist/styles.css';

import CommonService from '../../services/commonService';
import { Fade } from 'react-slideshow-image';
import React from 'react';

const fadeProperties = {
	duration: 4000,
	pauseOnHover: false,
	autoplay: true,
	indicators: true,
	arrows: false,
	// prevArrow: (
	//   <button className="home-banner-prevArrow">
	//     <img className="home-banner-arrow" src="/static/images/HomeBanner/Home-LeftArrow.svg" alt="" />
	//   </button>
	// ),
	// nextArrow: (
	//   <button className="home-banner-nextArrow">
	//     <img className="home-banner-arrow" src="/static/images/HomeBanner/Home-RightArrow.svg" alt="" />
	//   </button>
	// ),
};

const HomeBanners = props => {
	const operator = CommonService.getLocal('op');
	return (
		<div className="themes-home-banners" style={props.containerStyle}>
			<style>
				.react-slideshow-container + ul.indicators .each-slideshow-indicator.active:before{'{'}
				background: {props.activeDotColor}
				{'}'}
			</style>
			<Fade {...fadeProperties}>
				{props.slides &&
					(props.slides || []).map((fadeImage, index) => (
						<div className="each-fade" key={index}>
							<div className="image-container" style={{
								height: props.height ? props.height : '',
								marginTop: operator && operator.operator_name !== "aeroquinta" ? '80' : props.marginTop

							}}>
								{operator && operator.operator_name === "tacoha" ? (<img
									src={fadeImage}
									alt=""
									style={{ height: '100%', objectFit: '', width: '100%' }}
								/>) : (<img
									src={fadeImage}
									alt=""
									style={{ height: '100%', objectFit: 'contain', width: '100%' }}
								/>)}
							</div>
						</div>
					))}
			</Fade>
		</div>
	);
};

export default HomeBanners;



// WEBPACK FOOTER //
// ./src/features/themes/HomeBanners.js